import Markdown from "react-markdown";
export default function QuestionMarkdownPreview({ markdown }: { markdown: string }) {
    return (
        <div className="w-full px-4 sm:px-8 break-words text-center tracking-[-0.03em] leading-relaxed">
            <Markdown
                components={{
                    h2: ({ ...props }) => <h2 className="text-2xl font-semibold mt-5 mb-3" {...props} />,
                    em: ({ ...props }) => <span className="text-osGrey-2" {...props} />,
                }}
            >
                {markdown}
            </Markdown>
        </div>
    );
}